import type { TTab } from '../types/TTab';

const ASR_CONSOLE_TABS: TTab[] = ['playground', 'models', 'jobs', 'defaults'];

export const isAsrConsoleTab = (value: string | null): value is TTab =>
  value !== null && ASR_CONSOLE_TABS.includes(value as TTab);
